import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import styled from 'styled-components'
import Hero from './Hero/Hero'
import LocationsMap from './LocationsMap/LocationsMap'
import MachinesCarousel from './MachinesCarousel/MachinesCarousel'
import MoreFromHexagon from './MoreFromHexagon/MoreFromHexagon'
import Services from './Services/Services'
import TestimonialSlider from './TestimonialSlider/TestimonialSlider'

const HomePageContainer = styled.div`
  section {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  @media only screen and (max-width: 960px) {
    section {
      padding-top: 50px;
      padding-bottom: 50px;
    }
  }
`

const HomePage = () => {
  return (
    <HomePageContainer>
      <Hero />
      <Services />
      <TestimonialSlider />
      <LocationsMap />
      <MachinesCarousel />
      <MoreFromHexagon />
    </HomePageContainer>
  )
}

export default HomePage
